import React from 'react';
import { DynamicHeroSection } from '@/components/DynamicHeroSection';
import { EventType } from '@/utils/eventUtils';

interface HeroWithStatsProps {
  eventId?: string;
  eventType?: EventType;
  blockConfig?: any;
  title?: string;
  subtitle?: string;
  description?: string;
  primaryCTA?: string;
  secondaryCTA?: string;
  primaryCTALink?: string;
  secondaryCTALink?: string;
  stats?: Array<{
    value: string;
    label: string;
  }>;
  category?: string;
  backgroundImageOverride?: string;
  backgroundVideoUrl?: string;
  backgroundSettingsOverride?: {
    position?: string;
    size?: string;
    repeat?: string;
    opacity?: number;
  };
  disableInlineEdit?: boolean;
  phrases?: string[];
  cyclingWords?: string[];
}

export type { HeroWithStatsProps };

export function HeroWithStats({
  eventId,
  eventType = 'nomad-fest',
  blockConfig,
  title,
  subtitle,
  description,
  primaryCTA = "Get Your Tickets Now",
  secondaryCTA = "Learn More",
  primaryCTALink,
  secondaryCTALink,
  stats: propStats,
  category = 'festivals',
  backgroundImageOverride,
  backgroundVideoUrl,
  backgroundSettingsOverride,
  disableInlineEdit = false,
  phrases,
  cyclingWords,
}: HeroWithStatsProps) {
  const stats = blockConfig?.stats || propStats;

  return (
    <DynamicHeroSection
      eventId={eventId}
      eventType={eventType}
      title={title}
      subtitle={subtitle}
      description={description}
      primaryCTA={primaryCTA}
      secondaryCTA={secondaryCTA}
      primaryCTALink={primaryCTALink}
      secondaryCTALink={secondaryCTALink}
      stats={stats}
      category={category}
      backgroundImageOverride={backgroundImageOverride}
      backgroundVideoUrl={backgroundVideoUrl}
      backgroundSettingsOverride={backgroundSettingsOverride}
      disableInlineEdit={disableInlineEdit}
      phrases={phrases}
      cyclingWords={cyclingWords}
    />
  );
}
